import React from 'react'
import { Button, Card, Col, Modal, Row, Tooltip, OverlayTrigger, Form } from 'react-bootstrap';
import { ValidationForm, TextInput, SelectGroup, Checkbox } from 'react-bootstrap4-form-validation';
function DeleteConfirmation({ confirmation, setConfirmation, handleDelete, code }) {

    // console.log('confirmation?.details', confirmation?.details)
    return (
        <div>
            <Modal
                show={confirmation?.open}
                onHide={() => {


                    setConfirmation((prev) => {
                        return {
                            ...prev,
                            open: false
                        }
                    });
                }}
                animation={false}
            >
                <Modal.Header closeButton>
                    <Modal.Title>{`Are You Sure Want to Delete ? `}</Modal.Title>
                </Modal.Header>

                <Modal.Body>

                    <div>
                        <ValidationForm>
                            <Form.Group as={Col} sm={12} className="">

                                {code == 'GP' ? <>


                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}> General Header: </span> <span>{confirmation?.details?.fldGeneralHeader || 'NA'}</span>

                                    </div>

                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}> General Item : </span>
                                        <span>{confirmation?.details?.fldGeneralItem || 'NA'}</span>

                                    </div>

                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}> Item Description : </span>
                                        <span>{confirmation?.details?.fldItemDescription || 'NA'}</span>

                                    </div>

                                </> : <>

                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}> Style No : </span> <span>{confirmation?.details?.fldStyleNumber}</span>

                                    </div>

                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}> Sales Order No : </span>
                                        <span>{confirmation?.details?.fldSalesOrderNo}</span>

                                    </div>



                                    {code === 'ACC' ?

                                        <div style={{ margin: '5px' }}>
                                            <span style={{ fontWeight: 500 }}>  Accessories Name  : </span>

                                            <span>{confirmation?.details.fldFKAccessories || 'NA'}</span>
                                            {/* confirmation?.details?.tblFabricname ||  */}
                                        </div> : <div style={{ margin: '5px' }}>
                                            <span style={{ fontWeight: 500 }}>  Yarn Counts  : </span>

                                            <span>{code !== 'YRN' ? confirmation?.details.fldYarnCounts : confirmation?.details.fldYarnType || 'NA'}</span>
                                            {/* confirmation?.details?.tblFabricname ||  */}
                                        </div>
                                    }





                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}>  Color : </span>


                                        <span>{code !== 'YRN' ? confirmation?.details?.fldColour : confirmation?.details.fldColor || 'NA'}</span>

                                    </div>


                                    <div style={{ margin: '5px' }}>
                                        <span style={{ fontWeight: 500 }}>  Color Shade : </span>


                                        <span>{confirmation?.details?.fldColourShade || 'NA'}</span>

                                    </div>

                                </>}





                                <div style={{ display: 'flex', justifyContent: 'space-around', marginTop: '20px' }}>
                                    <Button
                                        className="btn-danger"
                                        onClick={() => {
                                            setConfirmation((prev) => {
                                                return {
                                                    ...prev,
                                                    open: false
                                                }
                                            });
                                        }}
                                        name="Close"
                                        value="Close"
                                        size="sm"
                                    >
                                        No
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            // dispatch(deleteFabricPoDetails(confirmation.id, singleFabricPoData?.fldId))

                                            handleDelete()
                                            setConfirmation((prev) => {
                                                return {
                                                    ...prev,
                                                    open: false
                                                }
                                            })
                                        }}
                                        className="btn-success"
                                        type="submit"
                                        // variant="secondary"
                                        size="sm"
                                    >
                                        Yes
                                    </Button>

                                </div>
                            </Form.Group>
                        </ValidationForm>

                    </div>
                    {/* <div style={{ marginTop: '10px' }}>
                        <div>

                            <input type='checkbox' />
                            <label style={{ marginLeft: '5px' }}>QtyRollBack</label>
                        </div>

                        <div>
                            <label className=''>Command <span className='text-danger'>*</span></label>
                            <div>
                                <textarea id="w3review" name="w3review" rows="4" cols="50" />
                            </div>


                        </div>
                    </div> */}
                </Modal.Body>

                {/* <Modal.Footer>
                    <Button
                        type="submit"
                        variant="secondary"
                        onClick={() => {
                            // dispatch(updateApiWhileDeletingCall(confirmation?.fldId))
                            // setConfirmation({
                            //     open: false
                            // })
                            // dispatch(fetchYarnPO(moment(startDate).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), unitId));
                        }}

                    >
                        Yes
                    </Button>



                    <Button
                        variant="primary"
                        onClick={() => {
                            setConfirmation((prev) => {
                                return {
                                    ...prev,
                                    open: false
                                }
                            });
                        }}
                    >
                        No
                    </Button>
                </Modal.Footer> */}
            </Modal>
        </div>
    )
}

export default DeleteConfirmation